<template>
  <div class="navbar">
    <div class="navbar-inner">
      <div class="navbar-logo">
        <img src="../assets/zhgjt.png" alt="logo" />
      </div>
      <div class="navbar-menu">
        <div class="navbar-menu">
          <div class="navbar-menu-item" :class="index == 0 ? 'activeds' : ''" @click="jumpsy">首页</div>
          <!-- 2 -->
          <div class="navbar-menu-item">
            <span class="navbar-menu-title" :class="index == 1 ? 'activeds' : ''" @click="jumpzhg(0)">走进智慧谷</span>
            <div class="navbar-dropdown">
              <div class="navbar-dropdown-item" @click="jumpzhg(1)">集团介绍</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(2)">创始人寄语</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(3)">企业文化</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(4)">发展纲要</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(5)">发展历程</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(6)">专家团队</div>
              <div class="navbar-dropdown-item" @click="jumpzhg(7)">企业荣誉</div>
            </div>
          </div>
          <!-- 3 -->
          <div class="navbar-menu-item">
            <span class="navbar-menu-title" :class="index == 2 ? 'activeds' : ''" @click="jumphx(0)">核心业务</span>
            <div class="navbar-dropdown">
              <div class="navbar-dropdown-item" @click="jumphx(1)">超算公有链智谷链</div>
              <div class="navbar-dropdown-item" @click="jumphx(2)">PAAS数字服务平台</div>
              <div class="navbar-dropdown-item" @click="jumphx(3)">CHAIN企链链改服务</div>
              <div class="navbar-dropdown-item" @click="jumphx(4)">企链通DAPP数商平台</div>
              <div class="navbar-dropdown-item" @click="jumphx(5)">智慧谷AI名片</div>
              <div class="navbar-dropdown-item" @click="jumphx(6)">数购通推客系统</div>
              <div class="navbar-dropdown-item" @click="jumphx(7)">智谷AI全能助手</div>
            </div>
          </div>
          <!-- 4 -->
          <div class="navbar-menu-item">
            <span class="navbar-menu-title" :class="index == 3 ? 'activeds' : ''" @click="jumpcj(0)">应用场景</span>
            <div class="navbar-dropdown">
              <div class="navbar-dropdown-item" @click="jumpcj(1)">数字生态</div>
              <div class="navbar-dropdown-item" @click="jumpcj(2)">数字支付</div>
              <div class="navbar-dropdown-item" @click="jumpcj(3)">数字商城</div>
              <div class="navbar-dropdown-item" @click="jumpcj(4)">数字治理</div>
              <div class="navbar-dropdown-item" @click="jumpcj(5)">数字金融</div>
              <div class="navbar-dropdown-item" @click="jumpcj(6)">数字城市</div>
              <div class="navbar-dropdown-item" @click="jumpcj(7)">数字直播</div>
              <div class="navbar-dropdown-item" @click="jumpcj(8)">数字文旅</div>
              <div class="navbar-dropdown-item" @click="jumpcj(9)">数字版权</div>
              <div class="navbar-dropdown-item" @click="jumpcj(10)">数字三农</div>
            </div>
          </div>
          <!-- 5 -->
          <div class="navbar-menu-item">
            <span class="navbar-menu-title" :class="index == 4 ? 'activeds' : ''" @click="jumpgh(0)">合作规划</span>
            <div class="navbar-dropdown">
              <div class="navbar-dropdown-item" @click="jumpgh(1)">合作流程</div>
              <div class="navbar-dropdown-item" @click="jumpgh(2)">合作收益</div>
              <div class="navbar-dropdown-item" @click="jumpgh(3)">未来规划</div>
              <div class="navbar-dropdown-item" @click="jumpgh(4)">全球战略</div>
              <div class="navbar-dropdown-item" @click="jumpgh(5)">合作伙伴</div>
            </div>
          </div>
          <div class="navbar-menu-item" :class="index == 5 ? 'activeds' : ''" @click="jumpxw(0)">新闻资讯</div>
          <!-- 7 -->
          <div class="navbar-menu-item">
            <span class="navbar-menu-title" :class="index == 6 ? 'activeds' : ''" @click="jumpjr(0)">加入我们</span>
            <div class="navbar-dropdown">
              <div class="navbar-dropdown-item" @click="jumpjr(1)">招贤纳才</div>
              <div class="navbar-dropdown-item" @click="jumpjr(2)">团队风采</div>
              <div class="navbar-dropdown-item" @click="jumpjr(3)">招商加盟</div>
              <div class="navbar-dropdown-item" @click="jumpjr(4)">联系我们</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    console.log(this.index, '1');
  },
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    // 1
    jumpsy() {
      this.$router.replace({ name: 'HelloWorld' })
    },
    // 2走进
    jumpzhg(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
    },

    // 3核心业务
    jumphx(a) {
      if (a == 2) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 3, time: timestamp } });
      } else if (a == 3) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 5, time: timestamp } });
      } else if (a == 4) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 8, time: timestamp } });
      } else if (a == 5) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 11, time: timestamp } });
      } else if (a == 6) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 12, time: timestamp } });
      }else if (a == 7) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: 15, time: timestamp } });
      }
       else {
        let timestamp = Date.now();
        this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } });
      }
    },
    // 4应用场景
    jumpcj(a) {
      console.log(a)
      if (a == 5) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 8, time: timestamp } })
      } else if (a == 6) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 12, time: timestamp } });
      }else if (a == 7) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 13, time: timestamp } });
      }else if (a == 8) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 14, time: timestamp } });
      }else if (a == 9) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 15, time: timestamp } });
      }else if (a == 10) {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: 16, time: timestamp } });
      }else {
        let timestamp = Date.now();
        this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
      }
    },
    // 5合作规划
    jumpgh(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
    },
    // 6新闻资讯
    jumpxw(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'news', query: { num: a, time: timestamp } })
    },
    // 7加入我们
    jumpjr(a) {
      let timestamp = Date.now();
      this.$router.replace({ name: 'join', query: { num: a, time: timestamp } })
    },
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  width: 100%;
  background: #fff;
  padding: 0;
  position: fixed;
  top: 0;
  z-index: 999;
  height: 60px;
}

.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  /* margin-top: 5px; */
}

.navbar-logo {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-top: -10px;
}

.navbar-logo img {
  width: 110px;
  height: 40px;
  margin-right: 8px;
}

.navbar-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.navbar-menu {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.navbar-menu-item {
  position: relative;
  font-size: 16px;
  color: #545b64;
  cursor: pointer;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  top: -5px;
}

.navbar-menu-item.active {
  color: #409eff;
}

.navbar-menu-title {
  color: inherit;
  font-size: 16px;
  margin-bottom: 6px;
}

.navbar-dropdown {
  display: none;
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 8px;
  min-width: 180px;
  z-index: 10;
  text-align: center;
  padding: 12px 0;
}

.navbar-menu-item:hover .navbar-dropdown {
  display: block;
}

.navbar-dropdown-item {
  padding: 10px 0;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: background 0.2s;
}

.navbar-dropdown-item:hover {
  color: #409eff;
}

.navbar-menu-item.active {
  color: #409eff;
}

.navbar-menu-item:hover {
  color: #409eff;
}

.activeds {
  color: #409eff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue